export const getClusterParams = ({ object, layer, coordinate }: any) => {
  if (layer && object.cluster && coordinate) {
    const { state: { index } } = layer;
    const clusterExpansionZoom = index.getClusterExpansionZoom(object.cluster_id as number);
    const [lng, lat] = coordinate;

    return { lat, lng, expansionZoom: clusterExpansionZoom };
  }
};
